import { type LocationContent } from "@/components/location-page";
import { FEES, FIRM } from "@/lib/firm";

export const CONTENT: LocationContent = {
  slug: "pelican-waters",
  name: "Pelican Waters",
  title: "Pelican Waters conveyancing lawyers",
  metaTitle: `Pelican Waters Conveyancing Lawyers | ${FIRM.name}`,
  description: `Fixed-fee conveyancing for Pelican Waters — canal-front homes, new estate builds and off-the-plan. Sales ${FEES.sale} incl. GST. Wills and elder law too. Call ${FIRM.phone}.`,
  lead: "Pelican Waters is one of the most active property markets on the southern Sunshine Coast, and one of the most detail-heavy. Canal frontage, community title, new builds and off-the-plan contracts all carry their own traps.",
  paragraphs: [
    "We are just up the road in Golden Beach and act regularly for Pelican Waters buyers and sellers. Between the marina precinct, the golf course, the newer estate releases and the established canal-front homes, no two contracts look quite the same.",
    "The most common problem we see is buyers signing a builder's or developer's contract without advice, then discovering the variation clauses, the sunset date, or the extent of the community title obligations only after they are bound.",
    "Our fee is fixed and agreed before we start, whatever kind of Pelican Waters contract you are dealing with.",
  ],
  person: "erin-wilkinson",
  localNotes: [
    {
      t: "Canal frontage and pontoons",
      d: "Revetment wall responsibility, pontoon approvals and any waterway authority conditions need to be confirmed. These obligations run with the land and can be expensive.",
    },
    {
      t: "Off-the-plan and sunset dates",
      d: "A sunset date lets the developer terminate if the plan is not registered in time. We check the disclosure statement, the variation rights and what protections you actually have.",
    },
    {
      t: "House and land / building contracts",
      d: "A land contract plus a build contract is two agreements with different risks. Progress payments, variations and delay clauses deserve a read before you sign.",
    },
    {
      t: "Community title obligations",
      d: "Estate covenants and community management statements can control fencing, colours, landscaping and even when your build must start. Buyers are routinely surprised by these.",
    },
  ],
  suburbs: ["Golden Beach", "Caloundra", "Bells Creek", "Aroona", "Little Mountain", "Baringa"],
  faqs: [
    {
      q: "Should I get advice before signing an off-the-plan contract?",
      a: "Yes. Off-the-plan contracts are drafted for the developer, and once signed your rights are largely limited to what the disclosure regime gives you. A pre-signing review is the cheapest protection available.",
    },
    {
      q: "Do you act on house and land packages?",
      a: "Yes. We handle the land conveyance and review the building contract alongside it, so you understand how the two fit together and what happens if the build is delayed.",
    },
    {
      q: "What extra searches apply to canal-front property?",
      a: "In addition to the standard searches we look at the plan and any easements, revetment wall and pontoon approvals, and community title or body corporate obligations attaching to the waterway.",
    },
  ],
};
